import { __extends } from "tslib";
var Record = /** @class */ (function () {
    function Record(name, _subrecord) {
        if (_subrecord === void 0) { _subrecord = false; }
        this.name = name;
        this._subrecord = _subrecord;
        this._records = {};
        this._startTime = 0;
        this._endTime = 0;
        this._subs = [];
        this._state = 0 /* NONE */;
    }
    Record.prototype.rec = function (name, subrecrod) {
        if (subrecrod === void 0) { subrecrod = false; }
        if (this._subrecord) {
            throw 'Suprecord can\'t support nested records!';
        }
        var sub = this._subs[this._subs.length - 1];
        if (!(sub && sub._state === 1 /* BEGIN */)) {
            sub = this;
        }
        return sub._records[name] || (sub._records[name] = new Record(name, subrecrod));
    };
    Record.prototype.begin = function () {
        if (this._state !== 0 /* NONE */) {
            return;
        }
        if (!this._subrecord) {
            if (this._subs[this._subs.length - 1]) {
                this._subs[this._subs.length - 1].end();
            }
            var sub = this.rec(this.name + '_' + this._subs.length, true);
            this._subs.push(sub);
            return sub.begin();
        }
        this._state = 1 /* BEGIN */;
        return this._startTime = performance.now();
    };
    Record.prototype.end = function () {
        for (var key in this._records) {
            this._records[key].end();
        }
        if (this._state !== 1 /* BEGIN */) {
            return;
        }
        if (!this._subrecord) {
            return this._subs[this._subs.length - 1].end();
        }
        this._state = 2 /* END */;
        this._endTime = performance.now();
        return this._endTime - this._startTime;
    };
    Record.prototype.drop = function () {
        this.end();
        if (!this._subrecord) {
            return this._subs[this._subs.length - 1].drop();
        }
        this._state = 3 /* DROP */;
        this._startTime = this._endTime = 0;
    };
    Object.defineProperty(Record.prototype, "startTime", {
        get: function () {
            if (this._state == 3 /* DROP */) {
                return 0;
            }
            var startTime = this._startTime || Number.MAX_VALUE;
            for (var key in this._records) {
                var r = this._records[key];
                startTime = Math.min(startTime, r.startTime);
            }
            return startTime;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Record.prototype, "endTime", {
        get: function () {
            if (this._state == 3 /* DROP */) {
                return 0;
            }
            var endTime = this._endTime || -Number.MAX_VALUE;
            for (var key in this._records) {
                var r = this._records[key];
                endTime = Math.max(endTime, r.endTime);
            }
            return endTime;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Record.prototype, "duration", {
        get: function () {
            if (this._state == 3 /* DROP */) {
                return 0;
            }
            var len = Object.keys(this._records).length;
            if (!len) {
                return this._endTime - this._startTime;
            }
            var duration = 0;
            for (var key in this._records) {
                duration += this._records[key].duration;
            }
            return duration;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Record.prototype, "selfDuration", {
        get: function () {
            var len = Object.keys(this._records).length;
            if (!len) {
                return this._endTime - this._startTime;
            }
            return this.endTime - this.startTime;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Record.prototype, "density", {
        get: function () {
            if (this._state == 3 /* DROP */) {
                return 0;
            }
            return this.duration / this.selfDuration;
        },
        enumerable: true,
        configurable: true
    });
    Record.prototype.toString = function () {
        var selfDuration = this.selfDuration;
        return "Name: " + this.name + ", duration: " + this.duration.toFixed(2) + "ms, self: " + selfDuration.toFixed(2) + "ms, density:" + (this.density * 100).toFixed(0) + "%";
    };
    Record.prototype.toTable = function (ident, filter) {
        if (ident === void 0) { ident = 0; }
        var r = '  '.repeat(ident) + this.toString() + '\n';
        if (this._subs.length === 1 && Object.keys(this._records).length === 1) {
            return r;
        }
        for (var key in this._records) {
            var rec = this._records[key];
            if (rec._state === 3 /* DROP */) {
                continue;
            }
            if (filter && filter(rec)) {
                continue;
            }
            r += rec.toTable(ident + 1, filter);
        }
        return r;
    };
    return Record;
}());
export { Record };
var Stat = /** @class */ (function (_super) {
    __extends(Stat, _super);
    function Stat() {
        var _this = _super.call(this, 'ROOT') || this;
        //@ts-ignore
        window.AWAY_ROOT_STAT = _this;
        return _this;
    }
    Stat.rec = function (name) {
        if (!this._instance) {
            this._instance = new Stat();
        }
        return this._instance.rec(name);
    };
    return Stat;
}(Record));
export { Stat };
